/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Privilege
 */
export interface Privilege {
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    action?: PrivilegeActionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Privilege
     */
    hierarchy?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum PrivilegeActionEnum {
    Read = 'READ',
    Write = 'WRITE',
    Deny = 'DENY'
}

export function PrivilegeFromJSON(json: any): Privilege {
    return PrivilegeFromJSONTyped(json, false);
}

export function PrivilegeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Privilege {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'hierarchy': !exists(json, 'hierarchy') ? undefined : json['hierarchy'],
    };
}

export function PrivilegeToJSON(value?: Privilege | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'action': value.action,
        'hierarchy': value.hierarchy,
    };
}

